import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

/** The heading of a card inside a detail page's tab, shared across the detail pages so their tabs read as one thing. */
export const SectionTitle = ({ children }: { children: ReactNode }) => (
  <Typography variant="subtitle1" fontWeight={600}>
    {children}
  </Typography>
);
